import React, { useEffect, useState } from 'react';
import { LeasesBasicDetails, LeasesNav } from '../../elements';
import { Grid, Paper, Tooltip, Typography } from '@mui/material';
import FolderSkyIcon from "../../../../src/assets/img/FolderSkyIcon.svg";
import ArrowCircleLeftOutlinedIcon from '@mui/icons-material/ArrowCircleLeftOutlined';
import { globalGetService } from '../../../utils/globalApiServices';
import { getSystemDocumentAssembliesApi } from '../apiService';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { checkApiStatus } from '../../../utils';
import { PageLoader } from '../../../shared_elements';
import { isMobile } from 'react-device-detect';
import { trackActivity } from '../../../utils/mixpanel';
import { useSelector } from 'react-redux';
import ModuleNotExcessModal from '../../../shared_elements/components/ModuleNotExcessModal';

const SystemDocumentsSubModules = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { leaseSlug, module } = useParams();
    const params = { leaseSlug, module };
    const [skeletonLoader, setSkeletonLoader] = useState(true);
    const [isLoading, setLoading] = useState(false);
    const [assemblies, setAssemblies] = useState([]);
    const { leaseBasicDetails } = useSelector((state) => state.leases);
    const toTitleCase = (str) => str?.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()) || '';
    const moduleLabel = location.state?.displayName || toTitleCase(module);
    useEffect(() => {
        trackActivity('Page Viewed', { page_title: `System Documents - ${moduleLabel}` });
    }, []);

    useEffect(() => {
        if (!leaseBasicDetails?.status) return;
        getAssemblies();
    }, [leaseBasicDetails?.status]);

    const getAssemblies = () => {
        setSkeletonLoader(true);
        globalGetService(getSystemDocumentAssembliesApi(params), {})
            .then(response => {
                setSkeletonLoader(false);
                if (checkApiStatus(response)) {
                    setAssemblies(response?.data?.data || []);
                }
            });
    };

    return (
        <>
            <LeasesBasicDetails />
            <Paper className='lease-details-section lease-nav-module-margin' elevation={0} sx={{ boxShadow: "0px 0px 2px 1px #BBBBBB" }}>
                <LeasesNav />
                {leaseBasicDetails && Object.keys(leaseBasicDetails).length > 0 && !leaseBasicDetails?.status
                    ? <ModuleNotExcessModal leaseNotFound />
                    : (
                        <div className='lease-details-content'>
                            <Paper square className="responsive-paper">
                                <Grid container spacing={1} className="responsive-grid" alignItems='flex-end'>
                                    <Grid item md={4} xs={12} className="menu-container lease-list-link-mt">
                                        <span onClick={() => navigate(`/lease/${leaseSlug}/system-documents`)} style={{ color: "#1976d2", cursor: 'pointer', fontSize: "13px", fontWeight: "bold", fontFamily: "Roboto" }} >
                                            <Tooltip title="Back"> <ArrowCircleLeftOutlinedIcon sx={{ verticalAlign: '-webkit-baseline-middle', marginBottom: '8px', fontSize: '24px' }} color='primary' fontSize='small' /> </Tooltip>
                                            {' '}System Documents
                                        </span>
                                    </Grid>
                                    <Grid item md={8} xs={12}></Grid>
                                </Grid>
                            </Paper>
                            {skeletonLoader ? (
                                <PageLoader count={7} />
                            ) : assemblies.length > 0 ? (
                                <div className='lease-detail-table'>
                                    <div className='tab-detail-container'>
                                        <Grid container spacing={isMobile ? 3 : 5}>
                                            {assemblies.map((item) => (
                                                <Grid key={item.slug} size={{ md: 2, xs: 4 }}>
                                                    <div
                                                        style={{ justifySelf: "anchor-center", cursor: 'pointer' }}
                                                        onClick={() => { navigate( `/lease/${leaseSlug}/system-document/${module}/assemblies/${item.slug}`, { state: { displayName: moduleLabel, subFolderName: item.asset_name } } );
                                                            trackActivity('Item Clicked', { page_title: `System Documents - ${moduleLabel}`, page_type: `Clicked on Assembly Folder (${item.asset_name})` });
                                                        }}
                                                    >
                                                        <img src={FolderSkyIcon} alt="FolderSkyIcon" />
                                                    </div>
                                                    <div style={{ justifySelf: "anchor-center" }}>
                                                        <Typography className='system-doc-title' variant='h7'> {item.asset_name} <span>({item.file_count})</span> </Typography>
                                                    </div>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </div>
                                </div>
                            ) : (
                                <Typography className='no-record-found'>No Assemblies Found</Typography>
                            )}
                        </div>
                    )}
            </Paper>
            {isLoading ? <PageLoader /> : null}
        </>
    );
};

export default SystemDocumentsSubModules;
